module.exports = __webpack_public_path__ + "img/img31_1.bef4a1a5.svg";